import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import email from '../../../../../images/email.svg';

import Title from '../PopConfirm';

export default class EmailReset extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    passwordReset: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };
  static defaultProps = {
    tooltip: '',
  };
  render() {
    const { title, tooltip, passwordReset, name, id } = this.props;
    return (
      <React.Fragment>
        <span data-tip={tooltip} data-for={`tooltip-${title}`}>
          <Popconfirm
            title={
              <Title
                title="Send Password Change Request Email?"
                text={`This will allow ${name} to change their password and log into the ICON Portal
                application.`}
                style={{ maxWidth: '40vw' }}
              />
            }
            okText="Send"
            cancelText="Cancel"
            icon={<QuestionCircleOutlined style={{ color: 'orange' }} />}
            onConfirm={() => passwordReset(id)}
          >
            <button
              style={{
                border: 'none',
                backgroundColor: 'Transparent',
                cursor: 'pointer',
              }}
            >
              <img
                className="nf-loading__img"
                src={email}
                alt="Email User Password Reset"
              />
            </button>
          </Popconfirm>
        </span>
        <ReactTooltip
          id={`tooltip-${title}`}
          type="dark"
          effect="float"
          delayShow={350}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/ViewUsersGrid/subComponents/EmailReset/EmailReset.jsx